import {GlobalErrorHandler} from "./classes/global-error-handler";
import {LoadingInterceptor} from "./classes/loading-interceptor";

export {
  LoadingInterceptor,
  GlobalErrorHandler
}
